(() => {
  'use strict';
  if (customElements.get('loovi-cart-countdown')) return;

  const STORAGE_KEY = 'loovi-cart-reminder-v1';
  const DURATION = 5 * 60 * 1000;
  let deadline = null;
  let interval = null;
  let scheduled = false;
  let observedDrawer = null;
  let drawerObserver = null;

  try {
    const saved = Number(sessionStorage.getItem(STORAGE_KEY));
    if (Number.isFinite(saved) && saved > 0) deadline = saved;
  } catch (_) {
    // A blocked storage area still permits an in-memory reminder for this page.
  }

  function saveDeadline(value) {
    deadline = value;
    try {
      if (value === null) sessionStorage.removeItem(STORAGE_KEY);
      else sessionStorage.setItem(STORAGE_KEY, String(value));
    } catch (_) {
      // Never interrupt shopping because browser storage is unavailable.
    }
  }

  function stopTicking() {
    clearInterval(interval);
    interval = null;
  }

  function setText(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }

  function sync() {
    const drawer = document.querySelector('cart-drawer');
    const view = document.querySelector('#CartDrawer loovi-cart-countdown');
    if (!drawer) { stopTicking(); return; }
    if (observedDrawer !== drawer) {
      drawerObserver?.disconnect();
      observedDrawer = drawer;
      // The theme emits its open event before asynchronously adding "active".
      // Observe the actual state so the reminder starts and stops with the drawer.
      drawerObserver = new MutationObserver(scheduleSync);
      drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    const empty = view
      ? Number(view.dataset.merchandiseCount) === 0
      : Boolean(drawer.querySelector('cart-drawer-items.is-empty'));
    if (empty) {
      saveDeadline(null);
      if (view) view.hidden = true;
      stopTicking();
      return;
    }
    if (!view) { stopTicking(); return; }

    const isOpen = drawer.classList.contains('active');
    if (deadline === null && isOpen) saveDeadline(Date.now() + DURATION);
    if (deadline === null) { view.hidden = true; stopTicking(); return; }

    view.hidden = false;
    const seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
    const finished = seconds === 0;
    const display = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
    setText(view.querySelector('[data-loovi-reminder-digits]'), display);
    setText(view.querySelector('[data-loovi-reminder-title]'), finished ? 'Dein Warenkorb wartet auf dich.' : 'Dein Einkaufs-Countdown');
    setText(view.querySelector('[data-loovi-reminder-note]'), finished ? 'Deine Auswahl bleibt erhalten.' : 'Deine Auswahl bleibt auch danach erhalten.');
    const digits = view.querySelector('[data-loovi-reminder-digits]');
    if (digits) digits.hidden = finished;
    view.dataset.finished = String(finished);
    view.setAttribute('aria-label', finished
      ? 'Dein Warenkorb wartet auf dich. Deine Auswahl bleibt erhalten.'
      : 'Dein Einkaufs-Countdown: fünf Minuten als Einkaufserinnerung. Deine Auswahl bleibt auch danach erhalten.');

    if (isOpen && !finished && !document.hidden) {
      if (interval === null) interval = setInterval(sync, 1000);
    } else stopTicking();
  }

  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(() => { scheduled = false; sync(); });
  }

  customElements.define('loovi-cart-countdown', class extends HTMLElement {
    connectedCallback() { scheduleSync(); }
    disconnectedCallback() { scheduleSync(); }
  });

  ['cart-drawer:open', 'cart-drawer:update', 'cart-drawer:render'].forEach(name => {
    document.addEventListener(name, scheduleSync);
  });
  document.addEventListener('visibilitychange', scheduleSync);
  window.addEventListener('pageshow', scheduleSync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
  else scheduleSync();
})();
